import React from "react";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { withStyles, Button } from "@material-ui/core";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import styles from "./styles";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import Tooltip from "../../../common/StyledToolTip";
import SearchBox from "../../../common/SearchBox";
import { withSnackbar } from "notistack";
import { csvFormulaInjectionSanitizer } from "../../../../utilities/csvUtils";
import { GroupAddOutlined } from "@material-ui/icons";
import drawerStyles from "./drawerStyles";
import AliasesUpdateForm from "./AliasUpdateForm";
import { getFormattedCustomerData } from "./utils";
import MergedCustomersGrid from "./Grid";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
class MergedCustomersReport extends React.Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.state = {
      mergedCustomers: null,
      quickFilterText: "",
      showAliases: false,
      selectedCustomer: null,
    };
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  componentDidMount() {
    this._isComponentMounted = true;
    this.getMergedCustomers();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userData.userProfile.terminal.id !==
      this.props.userData.userProfile.terminal.id
    ) {
      this.getMergedCustomers();
    }
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  getMergedCustomers = () => {
    getDataWithQueryString(
      "GetMergedCustomers",
      `terminalId=${this.props.userData.userProfile.terminal.id}`
    ).then(
      (response) => {
        if (this._isComponentMounted) {
          if (response.status === 200) {
            const formattedCustomers = getFormattedCustomerData(response.data);
            this.setState({
              mergedCustomers: formattedCustomers,
            });
          } else {
            this.setState({
              mergedCustomers: [],
            });
            this.handleError("Unable to fetch merged customers");
          }
        }
      },
      (error) => {
        if (this._isComponentMounted) {
          this.setState({
            mergedCustomers: [],
          });
          this.handleError("Unable to fetch merged customers");
        }
      }
    );
  };

  onSelectionChanged = () => {
    if (!this.state.showAliases) {
      const selectedCustomers = this.gridApi.getSelectedRows();
      this.setState({
        selectedCustomer: selectedCustomers[0],
      });
    }
  };

  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  exportCSV = () => {
    if (!this.state.mergedCustomers?.length || !this.gridApi) {
      return;
    }
    const columns = this.gridApi.getColumns();
    const columnKeys = columns
      .filter(column => !column.colDef.hide)
      .map(column => column.getColId());

    const params = {
      fileName: "Grouped_Customer_Report",
      columnKeys,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value),
    };
    this.gridApi.exportDataAsCsv(params);
  };

  showAliases = () => {
    this.setState({
      showAliases: true,
    });
  };

  closeDrawer = () => {
    this.setState({
      showAliases: false,
    });
  };

  handleError = (errorMessage) => {
    this.props.enqueueSnackbar(errorMessage, {
      variant: "error",
    });
  };

  render() {
    const { classes } = this.props;
    const { selectedCustomer } = this.state;
    return (
      <div className={classes.subModule}>
        <header
          className={`${classes.moduleHeader} ${classes.transition} ${
            this.state.showAliases ? classes.shiftedContent : ""
          }`}
        >
          <span>Grouped Customers</span>
          <div className={classes.headerActionIcons}>
            <Tooltip
              title={
                !selectedCustomer
                  ? "Disabled (Select a customer to show aliases)"
                  : ""
              }
            >
              <div className={classes.buttonContainer}>
                <Button
                  variant="outlined"
                  onClick={this.showAliases}
                  disabled={!selectedCustomer}
                  classes={{
                    root: classes.showAliasesButton,
                    disabled: classes.disabledButton,
                  }}
                >
                  <GroupAddOutlined className={classes.groupIcon} />
                  <span className={classes.buttonText}>Show Aliases</span>
                </Button>
              </div>
            </Tooltip>
            <SearchBox onChange={this.updateQuickFilterText} customSearchClass = {classes.customSearchWidth200}/>
            <ClearAllFilterButton gridApi={this.gridApi} />
            <span onClick={this.exportCSV} className={classes.headerIconStyles}>
              <Tooltip title="Export Data">
                <SaveAltSharp />
              </Tooltip>
            </span>
          </div>
        </header>
        <div
          className={`${classes.contentContainer} ${classes.transition} ${
            this.state.showAliases ? classes.shiftedContent : ""
          }`}
        >
          <MergedCustomersGrid
            rowData={this.state.mergedCustomers}
            onGridReady={this.onGridReady}
            quickFilterText={this.state.quickFilterText}
            onSelectionChanged={this.onSelectionChanged}
            onRowDataUpdated={this.onSelectionChanged}
            suppressRowClickSelection={this.state.showAliases}
            getRowId={(params) => params.data.originalCustomerId}
          />
        </div>
        {this.state.showAliases && (
          <AliasesUpdateForm
            variant="persistent"
            open={true}
            drawerClasses={{
              paper: `${classes.paperAnchor} customScroll ${
                !this.state.showAliases ? classes.paperHidden : ""
              }`,
              modal: classes.modal,
            }}
            BackdropProps={{
              className: classes.backdrop,
            }}
            closeDrawer={this.closeDrawer}
            originalCustomerName={selectedCustomer.originalCustomerName}
            duplicateCustomers={selectedCustomer.duplicateCustomers}
            getMergedCustomers={this.getMergedCustomers}
          />
        )}
      </div>
    );
  }
}
export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...drawerStyles(theme),
  })),
  withUserProfile,
  withSnackbar
)(MergedCustomersReport);
